module.exports = __webpack_public_path__ + "static/media/7.2062b145.jpg";